"use client";
import React from "react";
import { MdCancel } from "react-icons/md";
import AddRulesLogic from "./AddRulesLogic";
import "./AddRules.css";
import { IoChevronDown } from "react-icons/io5";
function AddRules({ onCancel, onSave, editData, fieldOptions = [] }) {
    const {
        ruleType,
        formData,
        handleChange,
        handleRuleTypeChange,
        handleSubmit,
        errors
    } = AddRulesLogic({ onCancel, onSave, editData });

    return (
        <div className="AR-modal">
            <div className="AR-body">

                {/* HEADER */}
                <div className="AR-header">
                    <span>{editData ? "Edit Rule" : "Add Rule"}</span>
                    <MdCancel size={24} className="AR-closeBtn" onClick={onCancel} />
                </div>

                {/* BODY */}
                <div className="AR-bodyMain">
                    <form onSubmit={handleSubmit}>

                        {/* Rule Type */}
                        <div className="AR-group inputsSet-AR input-text-enter1">
                            <label>Rule Type <span style={{ color: "#dc3545" }}>*</span></label>
                            <div className="AR-selectWrap">
                                <select
                                    className={`form-control AR-input AR-select ${errors.ruleType ? "input-error" : ""}`}
                                    value={ruleType}
                                    onChange={(e) => handleRuleTypeChange(e.target.value)}>
                                    <option value="required">required</option>
                                    <option value="regex">regex</option>
                                    <option value="compare">compare</option>
                                    <option value="length">length</option>
                                </select>
                                 <IoChevronDown className="AR-dropdownToggle" />
                            </div>
                            {errors.ruleType && <span className="error-msg">{errors.ruleType}</span>}
                        </div>

                        {/* REQUIRED */}
                        {ruleType === "required" && (
                            <div className="AR-group inputsSet-AR input-text-enter1">
                                <label>Message <span style={{ color: "#dc3545" }}>*</span></label>
                                <input
                                    name="requiredMessage"
                                    value={formData.requiredMessage}
                                    onChange={handleChange}
                                    className={`form-control AR-input ${errors.requiredMessage ? "input-error" : ""}`}
                                    placeholder="Required message"/>
                                {errors.requiredMessage && <span className="error-msg">{errors.requiredMessage}</span>}
                            </div>
                        )}

                        {/* REGEX */}
                        {ruleType === "regex" && (
                            <>
                                <div className="AR-group inputsSet-AR input-text-enter1">
                                    <label>Pattern <span style={{ color: "#dc3545" }}>*</span></label>
                                    <input
                                        name="pattern"
                                        value={formData.pattern}
                                        onChange={handleChange}
                                        className={`form-control AR-input ${errors.pattern ? "input-error" : ""}`}
                                        placeholder="Regex pattern"/>
                                    {errors.pattern && <span className="error-msg">{errors.pattern}</span>}
                                </div>
                                <div className="AR-group inputsSet-AR input-text-enter1">
                                    <label>Message <span style={{ color: "#dc3545" }}>*</span></label>
                                    <input
                                        name="regexMessage"
                                        value={formData.regexMessage}
                                        onChange={handleChange}
                                        className={`form-control AR-input ${errors.regexMessage ? "input-error" : ""}`}
                                        placeholder="Validation message"/>
                                    {errors.regexMessage && <span className="error-msg">{errors.regexMessage}</span>}
                                </div>
                            </>
                        )}

                        {/* COMPARE */}
                        {ruleType === "compare" && (
                            <>
                                <div className="AR-group inputsSet-AR input-text-enter1">
                                    <label>Compare Field <span style={{ color: "#dc3545" }}>*</span></label>
                                    <div className="AR-selectWrap">
                                        <select
                                            name="compare_field"
                                            value={formData.compare_field}
                                            onChange={handleChange}
                                            className={`form-control AR-input AR-select ${errors.compare_field ? "input-error" : ""}`}>
                                            <option value="">Select Field</option>
                                            {fieldOptions.map((field, index) => (
                                                <option key={index} value={field}>{field}</option>
                                            ))}
                                        </select>
                                        <IoChevronDown className="AR-dropdownToggle" />
                                    </div>
                                    {errors.compare_field && <span className="error-msg">{errors.compare_field}</span>}
                                </div>

                                <div className="AR-group inputsSet-AR input-text-enter1">
                                    <label>Operator <span style={{ color: "#dc3545" }}>*</span></label>
                                    <div className="AR-selectWrap">
                                        <select
                                            name="operator"
                                            value={formData.operator}
                                            onChange={handleChange}
                                            className={`form-control AR-input AR-select ${errors.operator ? "input-error" : ""}`}>
                                            <option value="">Select</option>
                                            <option value=">">Greater</option>
                                            <option value="<">Less</option>
                                            <option value="=">Equal</option>
                                            <option value=">=">&gt;=</option>
                                            <option value="<=">&lt;=</option>
                                            <option value="!=">!=</option>
                                        </select>
                                        <IoChevronDown className="AR-dropdownToggle" />
                                    </div>
                                    {errors.operator && <span className="error-msg">{errors.operator}</span>}
                                </div>

                                <div className="AR-group inputsSet-AR input-text-enter1">
                                    <label>Message <span style={{ color: "#dc3545" }}>*</span></label>
                                    <input
                                        name="compareMessage"
                                        value={formData.compareMessage}
                                        onChange={handleChange}
                                        className={`form-control AR-input ${errors.compareMessage ? "input-error" : ""}`}
                                        placeholder="Compare message"/>
                                    {errors.compareMessage && <span className="error-msg">{errors.compareMessage}</span>}
                                </div>
                            </>
                        )}

                        {/* LENGTH */}
                        {ruleType === "length" && (
                            <>
                                <div className="AR-group inputsSet-AR input-text-enter1">
                                    <label>Min <span style={{ color: "#dc3545" }}>*</span></label>
                                    <input
                                        type="text"
                                        inputMode="numeric"
                                        pattern="[0-9]*"
                                        name="min"
                                        value={formData.min}
                                        onChange={handleChange}
                                        className={`form-control AR-input ${errors.min ? "input-error" : ""}`}
                                        placeholder="Enter minimum value"/>
                                    {errors.min && <span className="error-msg">{errors.min}</span>}
                                </div>

                                <div className="AR-group inputsSet-AR input-text-enter1">
                                    <label>Max <span style={{ color: "#dc3545" }}>*</span></label>
                                    <input
                                        type="text"
                                        inputMode="numeric"
                                        pattern="[0-9]*"
                                        name="max"
                                        value={formData.max}
                                        onChange={handleChange}
                                        className={`form-control AR-input ${errors.max ? "input-error" : ""}`}
                                        placeholder="Enter maximum value"/>
                                    {errors.max && <span className="error-msg">{errors.max}</span>}
                                </div>

                                <div className="AR-group inputsSet-AR input-text-enter1">
                                    <label>Message <span style={{ color: "#dc3545" }}>*</span></label>
                                    <input
                                        type="text"
                                        name="lengthMessage"
                                        value={formData.lengthMessage}
                                        onChange={handleChange}
                                        className={`form-control AR-input ${errors.lengthMessage ? "input-error" : ""}`}
                                        placeholder="Length validation message"/>
                                    {errors.lengthMessage && <span className="error-msg">{errors.lengthMessage}</span>}
                                </div>
                            </>
                        )}

                        {/* BUTTONS */}
                        <div className="AR-btnRow">
                            <button type="submit" className="AR-btn">
                                {editData ? "Update Rule" : "Save Rule"}
                            </button>
                            <button type="button" className="AR-btn AR-cancelBtn" onClick={onCancel}>
                                Cancel
                            </button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    );
}

export default AddRules;
